// src/pages/Produtos/profiles/imovel.js
export const imovelProfile = {
    id: 'imovel',
    labelForm: 'Gestão de Imóveis',
    tabs: {
        cabecalho: { enabled: true },
        industria: { enabled: false },
        materiaPrima: { enabled: false },
        modoProducao: { enabled: false },
        embalagens: { enabled: true },
        caracteristicas: { enabled: false },
        bens: { enabled: true },
        mobilia: { enabled: true },
        imagens: { enabled: true },
    },

    uiTabs: {
        cabecalho: {
            show: {
                //1ª div cabeçalho
                industria: false,
            },
        },
        bens: {
            titles: { grid: 'Informações específicas do imóvel' },
            labels: {
                grid: 'Imóvel',
                form: 'Informações do imóvel',
            },
            show: { veiculo: false, imovel: true, bemMovel: false, mobiliado: true, poco: true },
        },
    },

    parametros: {
        defaultsProduto: {
            bem: true,
            imovel: true,
            vtr: false,
            locavel: true, // geralmente imóvel
        },
        sanitize: {
            keepChildren: ['Empresa', 'NCM', 'Fabricante', 'produtoBens', 'produtoEmbalagens', 'produtoImagens'],
        },
    },
};
